import PropTypes from 'prop-types';

import useStyles from './useStyles';

const propTypes = {
  attributes: PropTypes.shape(),
  children: PropTypes.node,
  leaf: PropTypes.shape().isRequired,
};

const defaultProps = {
  attributes: null,
  children: null,
};

const LeafText = ({ attributes, children, leaf }) => {
  const styles = useStyles();

  return (
    <span
      {...attributes}
      {...(leaf.mark && { 'data-mark': leaf.mark })}
      {...(leaf.decoration && { 'data-decoration': leaf.decoration })}
      className={styles.root}
    >
      {children}
    </span>
  );
};

LeafText.propTypes = propTypes;
LeafText.defaultProps = defaultProps;

export default LeafText;
